import { QueryClient } from '@tanstack/react-query';
import { fenceSessionMutation, type AnyMutationOptions } from '@/lib/sessionMutationFence';

/**
 * Опции каждой мутации проходят через `defaultMutationOptions` — и у `useMutation`, и при
 * запуске: здесь их колбэки привязываются к сессии вкладки (`lib/sessionMutationFence.ts`).
 */
class SessionQueryClient extends QueryClient {
  override defaultMutationOptions<T extends AnyMutationOptions>(options?: T): T {
    return fenceSessionMutation(super.defaultMutationOptions(options));
  }
}

export const queryClient = new SessionQueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30000 },
  },
});
